import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      // className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500
      transition={{ duration: 0.6 }}
       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass-card shadow-charcoal' : 'bg-transparent'
      }`}
    >
      <div className="section-container">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          {/* <Link to="/" className="flex items-center space-x-3 group"> */}
          <Link to="/" className="flex items-center space-x-2 lg:space-x-3 group relative z-50">
            <div className="relative">
              {/* <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gold-gradient rounded-xl flex items-center justify-center gold-glow group-hover:animate-glow transition-all duration-300">
                <span className="text-cleantech-charcoal font-bold text-lg lg:text-xl">CT</span> */}
              <div className="w-8 h-8 lg:w-12 lg:h-12 rounded-lg lg:rounded-xl overflow-hidden shadow transition-all duration-300 group-hover:w-13 group-hover:h-13">
              <img
                src="/cleantech-logo.png"
                alt="Cleantech Logo"
                className="w-full h-full object-contain"
              />
            </div>

            </div>
            {/* <span className="text-xl lg:text-2xl font-bold text-cleantech-white"> */}
             <span className="text-lg lg:text-2xl font-bold text-cleantech-white">
              Clean<span className="text-gradient">Tech</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`relative py-2 text-sm font-medium transition-all duration-300 group ${
                  location.pathname === item.href
                    ? 'text-cleantech-gold'
                    : 'text-cleantech-white hover:text-cleantech-gold'
                }`}
              >
                {item.name}
                <span
                  className={`absolute bottom-0 left-0 h-0.5 bg-cleantech-gold transition-all duration-300 ${
                    location.pathname === item.href ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                />
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <Link to="/contact" className="btn-primary">
              Get Started
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-cleantech-white hover:text-cleantech-gold transition-colors duration-300 relative  touch-manipulation flex"
            aria-label="Toggle mobile menu"
            type="button"
          >
            {isMobileMenuOpen ? (
              <XMarkIcon className="w-6 h-6" />
            ) : (
              <Bars3Icon className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden glass-card border-t border-white/10 relative z-40"
          >
            <div className="section-container py-6">
              <nav className="flex flex-col space-y-4">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`py-3 text-lg font-medium transition-all duration-300 ${
                      location.pathname === item.href
                        ? 'text-cleantech-gold border-l-2 border-cleantech-gold pl-4'
                        : 'text-cleantech-white hover:text-cleantech-gold hover:pl-4'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="btn-primary mt-4 text-center inline-block"
                >
                  Get Started
                </Link>
              </nav>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;